export default __webpack_public_path__ + "static/media/gordijn_1.92db0fce.jpg";